import React, { useState } from 'react';
import { Card, Form, Button, Input, Divider, Typography, Modal, Space, message } from 'antd';
import Helmet from '../common/helmet';
import Password from '../common/password';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData } from '../../helpers/functions';
import { postRequest } from '../../helpers/apiCall';

const { Title, Text } = Typography;

const ChangePassword = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { isChaPassLoading } = useSelector(state => state.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [otp, setOtp] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  // Step 1: Request OTP
  const onFinish = async (values) => {
    try {
      const resp = await postRequest('request-change-password', {
        old_password: values.old_password,
      });

      if (resp?.data?.success) {
        setIsModalOpen(true);
        return;
      }
      message.error(resp.data.message || "Failed to request OTP");
    } catch (error) {
      message.error("Error requesting password change");
    }
  };

  const onFinishFailed = () => { };

  // Step 2: Verify OTP
  async function handleVerifyOtp() {
    setIsVerifying(true);
    try {
      const resp = await postRequest('verify-otp', {
        otp,
        password: form.getFieldValue('password'),
      });

      if (resp?.data?.success) {
        message.success("Password changed successfully!");
        setIsModalOpen(false);
        form.resetFields();
        // window.location.href = '/';
        return;
      }
      message.error(resp.data.message || "Invalid OTP");
    } catch (error) {
      message.error("Error verifying OTP");
    } finally {
      setIsVerifying(false);
    }
  }
  return (
    <>
      {getUserData()?.mode_of_login === "email" && (
        <div className="profile d-flex-a-c">
          <Helmet title="Change Password" />

          <div className="site-card-border-less-wrapper card-wrapper">
            <div style={{ color: "blue", paddingBottom: "1rem" }}>
              <Text >
                {window.location.search == "?fcp=true" && "It has been 60 days since you last changed your password. Please change it now."}
              </Text>
            </div>
            
            <Card bordered={false}>

              <p className="m-title f20 tl" >Change Password</p>

              <Form
                form={form}
                layout="vertical"
                name="basic"
                hideRequiredMark={true}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                {/* Current Password */}
                <Form.Item
                  label="Current password"
                  name="old_password"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter current password',
                    },
                  ]}
                >
                  <Input.Password size="large" placeholder="••••••••••" />
                </Form.Item>

                {/* New Password */}
                <Password isExtra={true} />

                {/* Confirm Password */}
                <Form.Item
                  label="Confirm Password"
                  name="password_confirmation"
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('The two passwords that you entered do not match!'),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password size="large" placeholder="••••••••••" />
                </Form.Item>

                <Divider className="mt40 mb40" />

                <Form.Item>
                  {/* <Button type="link" size={'large'} onClick={() => navigate('/profile')}>
                    Cancel
                  </Button> */}
                  <Button
                    type="primary"
                    htmlType="submit"
                    className=""
                    size="large"
                    disabled={isChaPassLoading}
                    loading={isChaPassLoading}
                  >
                    Update Password
                  </Button>
                </Form.Item>
              </Form>
            </Card>

            {/* OTP Modal */}
            <Modal
              open={isModalOpen}
              onCancel={() => setIsModalOpen(false)}
              footer={null}
              centered
              bodyStyle={{ textAlign: "center", padding: "32px" }}
            >
              <Title level={5}>Enter OTP sent to your email</Title>
              <Text type="secondary">
                Please enter the 8-digit code we just sent to your email.
              </Text>

              <div style={{ marginTop: 20 }}>
                <Input.OTP
                  length={6}
                  size="large"
                  style={{ justifyContent: "center", gap: "8px" }}
                  value={otp}
                  onChange={(value) => setOtp(value)}
                />
              </div>

              <Space style={{ marginTop: 24 }}>
                <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
                <Button
                  type="primary"
                  loading={isVerifying}
                  disabled={otp.length !== 6}
                  onClick={handleVerifyOtp}
                >
                  Verify
                </Button>
              </Space>
            </Modal>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangePassword;
